import { isEmpty, isNil } from "lodash-es";
import type { FormVersionDto, TemplateDto } from "../../services/ApiService";
import TemplateId from "../../state/TemplateId";
import type { Template, TemplateTag } from "../../types/Template";
import { fromLegacyPlatformIcon } from "../iconUtil";
import { resolveTheme } from "../themeUtil";
import { toFormVersion } from "./formVersion";
import FormVersionId from "../../state/FormVersionId";

const validTags = [
  "CONSTRUCTION",
  "INSTALLATION",
  "ENERGY_UTILITIES",
  "MANUFACTURING",
  "FACILITY",
  "SAFETY",
  "AUTOMOTIVE",
  "INFRASTRUCTURE",
  "REAL_ESTATE",
  "LOGISTICS",
  "OTHER",
  "MOST_POPULAR",
];

const fromLegacyTags = (tags: string[]): TemplateTag[] => {
  if (isEmpty(tags)) {
    return ["OTHER"];
  }

  const mappedTags = tags.map((tag) => {
    if (validTags.includes(tag)) {
      return tag as TemplateTag;
    }
    return "OTHER";
  });

  // If the only tag is MOST_POPULAR, we need to add an 'actual' tag
  if (mappedTags.length === 1 && mappedTags[0] === "MOST_POPULAR") {
    return ["OTHER", ...mappedTags];
  }

  return mappedTags;
};

export const toTemplate = (template: TemplateDto, publishedFormVersion: FormVersionDto | undefined): Template => {
  const publishedVersion = !isNil(template.publishedVersion?.formVersion)
    ? {
        formVersionId: FormVersionId.from(template.publishedVersion.formVersion),
        formVersion: !isNil(publishedFormVersion) ? toFormVersion(publishedFormVersion, false) : undefined,
        publishedDate: template.publishedVersion.publishedDate,
        publishedBy: template.publishedVersion.publishedBy,
      }
    : undefined;

  return {
    id: TemplateId.from(template.id),
    meta: {
      name: template.meta.name,
      description: template.meta.description,
      icon: fromLegacyPlatformIcon(template.meta.icon, "document"),
      theme: resolveTheme(template.meta.iconColor),
      language: template.meta.language ?? "en",
      tags: template.scope === "CUSTOMER" ? ["CUSTOM"] : fromLegacyTags(template.meta.tags),
    },
    publishedVersion,
    status: template.status,
    scope: template.scope,
  };
};
